import dayjs from "dayjs";
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";

import { IUploadHistory } from "./Governance.types";
import { GovernanceUserAvatar } from "./GovernanceUserAvatar";

type Props = {
  uploads: IUploadHistory[];
  onSelect: (upload: IUploadHistory) => void;
};

/**
 * O tema global aplica `backgroundColor: #FAFAFA !important`, `padding: 10px !important` e uma
 * borda a 12% de opacidade em toda `MuiTableCell` — os três só cedem com `!important`.
 */
const BORDER = "1px solid rgba(0, 0, 0, 0.05) !important";

const headerCellSx = {
  fontSize: "14px",
  color: "text.primary",
  backgroundColor: "#FFFFFF !important",
  padding: "18px 10px !important",
  borderBottom: BORDER,
};

const cellSx = {
  fontSize: "14px",
  color: "text.primary",
  backgroundColor: "#FFFFFF !important",
  padding: "20px 10px !important",
  borderBottom: BORDER,
};

export function GovernanceHistoryList({ uploads, onSelect }: Props) {
  return (
    <Table sx={{ backgroundColor: "white" }}>
      <TableHead>
        <TableRow>
          <TableCell sx={headerCellSx}>Usuário</TableCell>
          <TableCell sx={headerCellSx}>Arquivo</TableCell>
          <TableCell sx={headerCellSx}>Data de criação</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {uploads.map((upload) => (
          <TableRow
            key={upload.id}
            onClick={() => onSelect(upload)}
            sx={{
              cursor: "pointer",
              "&:hover": { backgroundColor: "rgba(48, 36, 225, 0.04)" },
            }}
          >
            <TableCell sx={cellSx}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <GovernanceUserAvatar name={upload.user?.name ?? null} />
                {upload.user?.name ?? "—"}
              </Box>
            </TableCell>
            <TableCell sx={cellSx}>{upload.fileName ?? "—"}</TableCell>
            <TableCell sx={cellSx}>{dayjs(upload.createdAt).format("DD/MM/YYYY - HH:mm:ss")}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
